import Img from 'components/Img';
import { LayoutContainer } from 'components/Layout';
import RichText from 'components/RichText';
import Text from 'components/Text';
import type { DigizuiteAsset } from 'models/asset';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import type { HTMLString } from 'types';
import { getEditorMargin } from 'utils/business-logic';
import { getAsset } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		content: Field<HTMLString>;
		heading: Field<string>;
		svgImage?: Field<DigizuiteAsset[]>;
	};
}

export default function CreditWarning({ fields, params }: Props) {
	if (!fields) {
		return null;
	}
	const icon = getAsset('Source Copy', fields.svgImage?.value);
	return (
		<LayoutContainer
			outerClassName={getEditorMargin(params)}
			innerClassName="flex"
		>
			{icon && (
				<Img
					src={icon.src}
					alt={icon.alt}
					className="mr-2 h-[4.5em] w-auto shrink-0"
					width={67}
					height={67}
					jpgOptimized={false}
				/>
			)}
			<div>
				<Text className="font-bold" as="pSmall" field={fields.heading} />
				<RichText className="text-sm" field={fields.content} />
			</div>
		</LayoutContainer>
	);
}
CreditWarning.displayName = 'CreditWarning';
